const dropdowns = [
  {
    link: '/react',
    text: 'React',
  },
  {
    link: '/wordpress',
    text: 'Wordpress',
  },
  {
    link: '/ecommerce',
    text: 'E-Commerce',
  },
  {
    link: '/graphics',
    text: 'UI/UX/LOGOS',
  },
  {
    link: '/applications',
    text: 'Applications',
  },
  {
    link: '/seo',
    text: 'SEO',
  },
];


export const HEADER = {
  home: [
    {
      link: '#home',
      text: 'Home',
    },
    {
      link: '#ideology',
      text: 'About',
    },
    {
      link: '#services',
      text: 'Services',
      submenu: dropdowns,
    },
    {
      link: '#work',
      text: 'Portfolio',
    },
    {
      link: '#contact',
      text: 'Contact',
    },
  ],

  react: [
    {
      link: '/',
      text: 'Home',
    },
    {
      link: '#ideology',
      text: 'About',
    },
    {
      link: '',
      text: 'Services',
      submenu: dropdowns,
    },
    {
      link: '#work',
      text: 'Portfolio',
    },
    {
      link: '#contact',
      text: 'Contact',
    },
  ],
  wordpress: [
    {
      link: '/',
      text: 'Home',
    },
    {
      link: '#ideology',
      text: 'About',
    },
    {
      link: '',
      text: 'Services',
      submenu: dropdowns,
    },
    {
      link: '#work',
      text: 'Portfolio',
    },
    {
      link: '#contact',
      text: 'Contact',
    },
  ],
  ecommerce: [
    {
      link: '/',
      text: 'Home',
    },
    {
      link: '#ideology',
      text: 'About',
    },
    {
      link: '',
      text: 'Services',
      submenu: dropdowns,
    },
    {
      link: '#work',
      text: 'Portfolio',
    },
    {
      link: '#contact',
      text: 'Contact',
    },
  ],
  applications: [
    {
      link: '/',
      text: 'Home',
    },
    {
      link: '#ideology',
      text: 'About',
    },
    {
      link: '',
      text: 'Services',
      submenu: dropdowns,
    },
    {
      link: '#contact',
      text: 'Contact',
    },
  ],
  graphics: [
    {
      link: '/',
      text: 'Home',
    },
    {
      link: '#ideology',
      text: 'About',
    },
    {
      link: '',
      text: 'Services',
      submenu: dropdowns,
    },
    {
      link: '#work',
      text: 'Portfolio',
    },
    {
      link: '#contact',
      text: 'Contact',
    },
  ],
  seo: [
    {
      link: '/',
      text: 'Home',
    },
    {
      link: '#ideology',
      text: 'About',
    },
    {
      link: '',
      text: 'Services',
      submenu: dropdowns,
    },
    {
      link: '#contact',
      text: 'Contact',
    },
  ],
};
